module.exports = __webpack_public_path__ + "img/pre-sales.7e7af801.svg";